import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { ErrorService } from './error.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  errorMessage: string = '';
  isFooterHidden = false;
  lastScrollTop = 0;

  constructor(
    private errorSerivce: ErrorService,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.errorSerivce.errorMessage$.subscribe((message) => {
      this.errorMessage = message;
      if (this.errorMessage == '') {
        this.isFooterHidden = true;
      } else {
        this.isFooterHidden = false;
      }
    });
  }

  /* @HostListener('window:scroll', [])
  onWindowScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop > this.lastScrollTop && this.errorMessage=='') {
          this.isFooterHidden = true; // Scrolling down
      } else {
          this.isFooterHidden = false; // Scrolling up
      }

      this.lastScrollTop = scrollTop;
  }*/
}
